import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { useIsUserVerified } from "Hooks/useIsUserVerified";

export const useIsTransferDisabled = () => {
  const { isUserVerified, isLoading: isLoadingVerification } =
    useIsUserVerified();
  const { isUserInBlockedMoonLite } = useIsUserInMooneLite();

  const isTransferDisabled =
    isLoadingVerification || !isUserVerified || isUserInBlockedMoonLite;

  return { isTransferDisabled };
};
